module.exports = __webpack_public_path__ + "img/logo_fill.bcaaa73f.svg";